export const PORTFOLIO_MONITOR_PAGE_TITLE = 'Portfolio Monitor';

export const portfolioMonitorNoAccessFeatures = [
  'See the latest secondary activity for your bond portfolio on an intuitive dashboard',
  'Instantly create custom portfolios and lists  to organize your securities',
  'Drill down into aggregated bond profiles of historical reports and current offers',
];

export const portfolioMonitorNoAccessDescription = 'Keep a constant pulse on US ABS secondary activity for your most actionable bonds on an organized dashboard that leverages Finsight’s award-winning BWIC, Inventory and TRACE modules.';

export const portfolioMonitorImageCaption = 'View the latest BWIC, Inventory and TRACE activity for bonds in your portfolio from an intuitive dashboard.';

export const MAX_NUMBER_OF_PORTFOLIOS = 20;
export const MAX_NUMBER_OF_LISTS_PER_PORTFOLIO = 10;
export const defaultCurrencyId = '96e6bf40-3b92-4501-943d-282deee59a23';

export const NO_POSITIONS_EMPTY_MESSAGE = 'No positions added';
